module.exports = __webpack_public_path__ + "static/media/ecoPays.51b611dc.svg";